import { getRetailerUserNotificationCount } from "@faire/retailer-visitor-shared/serialized-data/retailerUserNotificationCount";
import { Message } from "@faire/web--source/messenger/MessageChannel/MessageChannel";
import { IRetailerUserNotificationCount } from "@faire/web-api--source/indigofair/retailer/IRetailerUserNotificationCount";
import { RetailerUserNotificationGroup } from "@faire/web-api--source/indigofair/retailer/RetailerUserNotificationGroup";
import { IWebSocketMessage } from "@faire/web-api--source/indigofair/websockets/IWebSocketMessage";
import { useMemo } from "react";
import { useCallback } from "react";
import { create } from "zustand";

const useNotificationCountStore = create<{
  notificationCount: IRetailerUserNotificationCount | undefined;
  setNotificationCount: (
    notificationCount: IRetailerUserNotificationCount
  ) => void;
}>((set) => ({
  notificationCount: undefined,
  setNotificationCount: (notificationCount: IRetailerUserNotificationCount) =>
    set({ notificationCount }),
}));

export const useNotificationCount = () => {
  const notificationCount =
    useNotificationCountStore((s) => s.notificationCount) ??
    getRetailerUserNotificationCount();
  const setNotificationCount = useNotificationCountStore(
    (s) => s.setNotificationCount
  );

  const myTeamNotificationCount = useMemo(() => {
    return (
      notificationCount?.un_dismissed_notifications_count_by_group?.find(
        (group) =>
          group.group === RetailerUserNotificationGroup.TEAM_COMMUNICATION
      )?.count ?? 0
    );
  }, [notificationCount]);

  const notificationUpdateState = useMemo(() => {
    return {
      latestStatusUpdate: notificationCount?.latest_status_update,
      unviewedActiveNotificationCount:
        notificationCount?.unviewed_active_notification_count,
    };
  }, [notificationCount]);

  const handleRetailerUserNotificationChannelMessage = useCallback(
    (message: Message) => {
      if (
        message.type ===
          IWebSocketMessage.Type.RETAILER_USER_NOTIFICATION_COUNT_UPDATED &&
        !!message.retailer_user_notification_count
      ) {
        setNotificationCount(message.retailer_user_notification_count);
      }
    },
    [setNotificationCount]
  );

  return {
    myTeamNotificationCount,
    notificationUpdateState,
    handleRetailerUserNotificationChannelMessage,
  };
};
